"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addTrackingParams = exports.ADD_TRACKING_PARAMS = exports.TRACKING = void 0;
exports.TRACKING = '[Tracking]';
exports.ADD_TRACKING_PARAMS = `${exports.TRACKING} ADD`;
const addTrackingParams = (state = {}) => ({
    type: exports.ADD_TRACKING_PARAMS,
    payload: state,
    meta: { feature: exports.TRACKING },
});
exports.addTrackingParams = addTrackingParams;
//# sourceMappingURL=trackingAction.js.map